import { Link } from "react-router-dom";
import { site } from "@/config/site";
import { trendingTopics } from "@/mocks/site";

const heroTags = trendingTopics.map((item) => item.title);

export default function Hero() {
  return (
    <section className="relative overflow-hidden bg-foreground-950">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Abstract%20artistic%20stage%20with%20warm%20amber%20and%20coral%20spotlights%20cutting%20through%20soft%20smoky%20darkness%2C%20cinematic%20editorial%20background%2C%20rich%20warm%20tones%2C%20dramatic%20atmosphere&width=1600&height=900&seq=gu-hero-01&orientation=landscape"
          alt="诱惑吃瓜 首页头条视觉背景"
          title="诱惑吃瓜 - 精选头条热帖与高能猛料"
          className="h-full w-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/55 via-black/40 to-foreground-950/80" />
      </div>

      <div className="relative px-4 pb-14 pt-20 md:px-6 md:pb-20 md:pt-28">
        <div className="w-full max-w-3xl">
          <p className="mb-5 inline-flex items-center gap-2 rounded-full border border-background-100/30 bg-background-50/10 px-3.5 py-1.5 text-xs text-background-100 backdrop-blur-sm">
            <span className="flex h-1.5 w-1.5 items-center justify-center">
              <span className="h-1.5 w-1.5 animate-pulse rounded-full bg-accent-400" />
            </span>
            今日高能已更新 · {site.slogan}
          </p>
          <h1 className="text-balance font-heading text-3xl font-black leading-tight text-background-50 md:text-5xl">
            {site.name}：精选头条热帖，猛料爆评一网打尽
          </h1>
          <p className="mt-5 max-w-2xl text-sm leading-relaxed text-background-200/90 md:text-base">
            从剧集收官复盘到综艺名场面，从巡演现场到全网热议话题，我们把散落各处的瓜料整理成一条清晰的时间线，
            让你不用翻遍社交平台，也能看懂今天到底发生了什么。
          </p>
          <div className="mt-8 flex flex-col gap-3 sm:flex-row">
            <Link
              to="/news"
              className="inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-md bg-primary-500 px-6 py-3 text-sm font-medium text-background-50 transition-colors hover:bg-primary-600"
            >
              <i className="ri-fire-line" aria-hidden="true" />
              进入吃瓜现场
            </Link>
            <Link
              to="/news"
              className="inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-md border border-background-100/40 px-6 py-3 text-sm font-medium text-background-50 transition-colors hover:bg-background-50/10"
            >
              查看今日热榜
              <i className="ri-arrow-right-line" aria-hidden="true" />
            </Link>
          </div>

          <dl className="mt-10 grid max-w-xl grid-cols-3 gap-4 border-t border-background-100/20 pt-6">
            <div>
              <dt className="text-xs text-background-300/80">今日更新</dt>
              <dd className="mt-1 font-heading text-2xl font-bold text-accent-400">12 条</dd>
            </div>
            <div>
              <dt className="text-xs text-background-300/80">内容栏目</dt>
              <dd className="mt-1 font-heading text-2xl font-bold text-accent-400">6 个</dd>
            </div>
            <div>
              <dt className="text-xs text-background-300/80">热榜话题</dt>
              <dd className="mt-1 font-heading text-2xl font-bold text-accent-400">8 个</dd>
            </div>
          </dl>
        </div>
      </div>

      <div className="relative border-t border-background-100/15 bg-foreground-950/60 py-3">
        <div className="flex w-max animate-marquee items-center gap-8 whitespace-nowrap">
          {[...heroTags, ...heroTags].map((tag, index) => (
            <span
              key={`${tag}-${index}`}
              className="flex items-center gap-2 text-xs text-background-200/80"
            >
              <i className="ri-fire-fill text-primary-400" aria-hidden="true" />
              {tag}
            </span>
          ))}
        </div>
      </div>
    </section>
  );
}